import { Dropdown } from "primereact/dropdown"
import { useEffect, useRef, useState } from "react"

import { ProgressBar } from "primereact/progressbar"
import { PiFarmFill } from "react-icons/pi"
import { TIPO_MASK } from "../Login"
import * as mapas from "../../utils/mapas"
import API from '../../api/API'
import { LoteType, ImovelType, STATUS } from "../../db/Orm"
import L from "leaflet"

type LotesAccordionTabProps = {
    lotes: Array<any>,
    setCount: Function,
    propriedades: Array<ImovelType>,
    setPropriedade?: Function,
    lockPropriedade?: boolean,
    propriedade?: ImovelType,
}
// } & AccordionTabProps

export const LotesSelect = (props: LotesAccordionTabProps) => {
    // export const LotesAccordionTab: FunctionComponent<LotesAccordionTabProps> = ({ children, ...props }) => {
    // export const createLotesAccordionTab = (props: LotesAccordionTabProps): JSX.Element => {
    const [propriedade, setPropriedade] = useState<any>(null)
    const [propriedades, setPropriedades] = useState<Array<ImovelType>>(props.propriedades || [])
    const [loading, setLoading] = useState<boolean>(false)
    const mapRef = useRef<any>()
    const [map, setMap] = useState<any>(null)
    const [pj, setPJ] = useState<boolean>(false)
    const [mask, setMask] = useState<string>(TIPO_MASK.PF)
    const _firstLoadRef = useRef<boolean>(true)
    const loadPropriedades = async () => {
        //console.log('Global User:', global.user)
        //TODO mandar o navigate ao inves de null ou receber propriedades do global
        // const propriedades = await getPropriedades(null, () => console.log('erro'), undefined, undefined, api.STATUS.APROVADO)
        const aprovadas = propriedades.filter((p: ImovelType) => p.status === STATUS.APROVADO)
        setPropriedades(aprovadas)
        // setPropriedades(propriedades.map((p: ImovelType) => {
        //     //console.log(`Propriedade ${p}`)
        //     return { name: p.nome, code: p.id, object: p }
        // }))
        setLoading(false)
    }
    useEffect(() => {
        // console.log('Lotes Select', props.propriedade)
        loadPropriedades()
    }, [])
    useEffect(() => {
        if (propriedades.length === 0) return
        if (propriedades[0].id === undefined) return
        if (props.propriedade === undefined) return
        const p = propriedades.filter(p => p.id === props.propriedade?.id)
        if (p.length !== 1) return
        setPropriedade(p[0])
        // console.log('Propriedade props', props.propriedade)
    }, [propriedades])
    useEffect(() => {
        setMask(pj ? TIPO_MASK.PJ : TIPO_MASK.PF)
    }, [pj])
    useEffect(() => {
        try {
            //console.log('Select Lotes Map current', mapRef.current)
            //console.log('Mapa', map)
            if (mapRef.current) {
                //console.log('Mapa', map)
                if (mapRef.current && !map) {
                    const map = mapas.createMapOnBahia(mapRef)
                    mapas.refreshingMap(map, setLoading)
                    setMap(map)
                }
                setTimeout(() => {
                }, 1); // Pequeno atraso para garantir que o Dialog esteja completamente renderizado
            }

            // return () => {
            //     if (mapa) {
            //         selectLotesMap.current.remove(); // Limpa o mapa quando o Dialog é fechado ou o componente desmontado
            //         setMapa(null);
            //     }
            // };
        } catch (e: any) { console.log('Error:', e) }
    }, [mapRef.current]);

    const [lotes2, setLotes2] = useState<Array<any>>([])
    const selectLote = (index: number, lote: LoteType, polygon: any) => {
        if (lotes2.length > 0) {
            if (lotes2[index].color === mapas.estiloSelected.fillColor) {
                props.lotes.splice(props.lotes.indexOf(lote), 1)
                polygon.setStyle(mapas.estiloArea)
                lotes2[index].color = mapas.estiloArea.fillColor
            }
            else {
                polygon.setStyle(mapas.estiloSelected)
                lotes2[index].color = mapas.estiloSelected.fillColor
                props.lotes.push(lote)
            }
        }
        props.setCount(props.lotes.length)
    }
    const carregarPropriedade = async () => {
        if (propriedade) {
            mapas.clearMap(map)
            props.setCount(0)
            props.lotes.splice(0, props.lotes.length)
            //console.log('Propriedade id:', propriedade.object.id)
            if (!_firstLoadRef.current || !props.propriedade) {
                props.setPropriedade && props.setPropriedade(propriedade)
            }
            _firstLoadRef.current = false
            const polig = await mapas.carregarZipFromURL(propriedade.poligono, mapas.estiloContorno)
            if (map && polig) {
                polig.addTo(map)
                // console.log('Propriedade Poligono:', polig)
                const bounds = polig.getBounds();
                if (bounds && bounds.isValid())
                    map?.flyToBounds(polig.getBounds())
                const data = (await API.getData(API.url + 'lotes/?propriedade=' + propriedade.id, null, () => console.log('Error')))
                lotes2.splice(0, lotes2.length);
                //console.log('data', data)
                data.map(async (lote: LoteType, index: number) => {
                    const p = await mapas.carregarZipFromURL(lote.poligono, mapas.estiloArea)
                    const polCenter = p.getBounds().getCenter()
                    //console.log('polygon', p, 'lote', lote)
                    p.addTo(map)
                    p.on('click', async () => { selectLote(index, lote, await p) })
                    const loteText = L.marker(polCenter, {
                        icon: L.divIcon({
                            html: lote.id?.toString(),
                            className: 'loteText',
                        }), interactive: false
                    })
                        .addTo(map)
                    lotes2.push({ index: index, lote: lote, poligono: await p, color: mapas.estiloArea.fillColor })
                });
            }
        }
    }
    useEffect(() => {
        carregarPropriedade()
        map?.invalidateSize();
    }, [propriedade])
    return (
        <>
            <div className="flex flex-column p-inputgroup flex-1">
                <span className="p-inputgroup-addon"><div style={{ display: 'flex', alignItems: 'center', marginLeft: 10, marginRight: 10 }}><PiFarmFill /><b style={{ paddingLeft: 1 }}>Propriedade</b></div></span>
                <span className="p-float-label">
                    <Dropdown name='propriedade' value={propriedade} onChange={(e) => setPropriedade(e.value)}
                        options={propriedades} optionLabel="nome" placeholder='Propriedade *' filter
                        disabled={props.lockPropriedade}
                    // disabled={props.propriedade !== undefined}
                    >
                        {loading && <ProgressBar mode='indeterminate' />}
                    </Dropdown>
                    <label htmlFor="propriedade">Selecione a propriedade</label>
                </span>
            </div>
            <div ref={mapRef} style={{ width: '100%', height: 300, backgroundColor: 'gray' }} />
        </>
    )
}